import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { ExploreLandingPageIcon } from './explore-landing-page';
import { exploreRootRouteRef } from '../../routes';

export const exploreLandingPage = PageBlueprint.make({
  params: {
    title: 'Explore',
    path: '/explore',
    icon: ExploreLandingPageIcon,
    routeRef: exploreRootRouteRef,
    loader: () =>
      import('./explore-landing-page').then(m => <m.ExploreLandingPage />),
  },
});

export const exploreLandingPagePlugin = createFrontendPlugin({
  pluginId: 'explore-landing-page',
  extensions: [exploreLandingPage],
});
